import Axios from 'axios';
import Cookies from 'js-cookie';

import AppConfig from 'config/App';

const request = is_external => {
  const ixn_auth = Cookies.getJSON('ixn') || {};
  const token = window.IXN_QUOTER_CONFIG?.id || window.HEXURE_UQ_CONFIG?.life_token || '';

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  };

  if (!is_external) {
    headers['BGA-QUOTER-TOKEN'] = token;
    headers['access-token'] = ixn_auth.access_token;
    headers['client'] = ixn_auth.client;
    headers['uid'] = ixn_auth.uid;
  }

  return Axios.create({
    baseURL: AppConfig.API_BASE_URL,
    headers
  });
};

const AlqApi = {
  loadBgaQuoter({ universal = false, id = '' } = {}) {
    if (!universal || !id || id.trim() === '') {
      universal = false;
      id = '';
    }
    if (universal) {
      const headers = {
        'BGA-QUOTER-TOKEN': id
      };
      return request().get(`/v1/bga_quotes/${id}`, { headers });
    }
    return request().get(`/v1/bga_quotes/${window.IXN_QUOTER_CONFIG.id}`);
  },

  loadCarriers(carrier_ids, beta = false) {
    const params = {
      id: carrier_ids
    };

    if (beta) {
      params.beta = true;
    }

    return request()
      .get('/v1/carriers', { params })
      .then(response => response.data);
  },

  loadProductFeatures({ universal = false, id = '' } = {}) {
    if (!universal || !id || id.trim() === '') {
      universal = false;
      id = '';
    }
    if (universal) {
      const headers = {
        'BGA-QUOTER-TOKEN': id
      };
      return request().get('/v1/product_features/', { headers });
    }
    return request()
      .get('/v1/product_features')
      .then(response => response.data);
  },

  loadUnderwritingGuides(carrier_ids) {
    return request()
      .get('/v1/underwriting_guides', {
        params: {
          carrier_id: carrier_ids
        }
      })
      .then(response => response.data);
  },

  calculateNeeds(params) {
    return request()
      .post('/v1/needs_calculations/', params)
      .then(response => {
        return response;
      });
  },

  loadFormTags() {
    return request()
      .get('/v1/form_tags')
      .then(response => {
        return response.data;
      });
  },

  loadQuoteForms(params) {
    return request()
      .get('/v1/forms/', { params })
      .then(response => {
        return response;
      });
  },

  loadAmbestRecord(carrier_id) {
    return request()
      .get('/v1/ambest_records/', { params: { carrier_id } })
      .then(response => {
        return response;
      });
  },

  loadProduct(id) {
    return request().get(`/v1/products/${id}`);
  },

  loadProducts(id) {
    return request().get('/v1/products', { params: { id } });
  },

  getQuotes(params, { universal = false, id = '' } = {}) {
    if (!universal || !id || id.trim() === '') {
      universal = false;
      id = '';
    }
    if (universal) {
      const headers = {
        'BGA-QUOTER-TOKEN': id
      };
      return request().post('/v1/quotes/', params, { headers });
    }
    return request()
      .post('/v1/quotes/', params)
      .then(response => {
        return response;
      });
  },

  emailQuotes(params) {
    return request().post('/v1/pdfs', params);
  },

  textQuotes(params) {
    return request().post('/v1/pdfs', params);
  },

  generateQuotesPdf(params) {
    return request().post('/v1/pdfs', params);
  },

  downloadStandardPacket(params) {
    return request().post('/v1/forms/standard_packet', params);
  },

  generateFormsPdf(params) {
    return request().post('/v1/forms', params);
  },

  requestForms(params) {
    return request().post('/v1/forms/request_forms', params);
  },

  postToWebhook(url, params) {
    return request(true).post(url, params);
  },

  createEticket(params) {
    return request().post('/v1/etickets', params);
  },

  updateEticket(id, params) {
    return request().put(`/v1/etickets/${id}`, params);
  },

  loadEticket(id) {
    return request().get(`/v1/etickets/${id}`);
  },
  getHorizonsLink(id) {
    return request().get(`/v1/etickets_horizon/${id}`);
  },

  createEApp(params) {
    return request().post('/v1/e_apps', params);
  },

  updateEApp(id, params) {
    return request().put(`/v1/e_apps/${id}`, params);
  },

  sendEAppLink(xml_id, params) {
    return request().post(`/v1/e_apps/${xml_id}/send_link`, params);
  },

  checkNewMemberEmail(email) {
    return request().post('/v1/member_exists', { email });
  },

  login(params) {
    return request().post('/v1/members/login', params);
  },

  logout() {
    return request().delete('/v1/members/logout');
  },

  loadMember(member_id) {
    return request().get(`/v1/members/${member_id}`);
  },

  register(params) {
    return request().post('/v1/members', params);
  },

  sendFeedback(params) {
    return request().post('/v1/feedback', params);
  },

  //-------vive simplified eticket------------

  //Is agency(user) registered with Vive system (Validate if provided agency (user) is registered with Vive system and can be used).
  validateViveUser(agencyCode, username) {
    const params = {
      agencyCode,
      username
    };
    return request()
      .get(`/v1/vive/user/is_registered`, { params })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return {
          error: error.message || 'User registration check failed',
          status: error.response?.status
        };
      });
  },

  //register agency(user) if not registered with Vive system.
  registerViveUser(params) {
    return request()
      .post('/v1/vive/user/register', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return {
          error: error.message || 'User registration failed',
          status: error.response?.status
        };
      });
  },

  //Validate if provided quote agency is registered, user is registered, and if quote can be created in Viveapplication with provided criteria.
  validateViveQuote(params) {
    return request()
      .post('/v1/vive/quote/validate', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return {
          error: error.message || 'Quote Validation failed',
          status: error.response?.status
        };
      });
  },

  //Creates quote for requested agency and user in Vive application with provided criteria.
  createViveQuote(params) {
    return request()
      .post('/v1/vive/quote/create', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return {
          error: error.message || 'Quote creation failed',
          status: error.response?.status
        };
      });
  },
  continueViveQuote(params) {
    return request()
      .post('/v1/vive/quote/continue', params)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error.message || 'Quote continuation failed' };
      });
  },

  // IUL-specific API endpoints
  loadIulPolicyFees(product_id) {
    return request()
      .get(`/v1/quotes/iul_policy_fees?product_id=${product_id}`)
      .then(response => response.data?.iulPolicyFees || [])
      .catch(error => {
        console.error('Error loading IUL policy fees:', error);
        return [];
      });
  },

  loadIulInvestments(product_id) {
    return request()
      .get(`/v1/quotes/investments?product_id=${product_id}`)
      .then(response => response.data?.investments || [])
      .catch(error => {
        console.error('Error loading IUL investments:', error);
        return [];
      });
  },

  loadIulRiders(product_id) {
    return request()
      .get(`/v1/quotes/life_rider_rates?product_id=${product_id}`)
      .then(response => response.data?.lifeRiders || [])
      .catch(error => {
        console.error('Error loading IUL riders:', error);
        return [];
      });
  }
};

export default AlqApi;
